<template>
    <Dialog>
        <DialogTrigger as-child>
            <Button variant="ghost" class="h-auto w-auto p-2">
                <span class="sr-only">View QR</span>
                <QrCodeIcon></QrCodeIcon>
            </Button>
        </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Short Link QR Code</DialogTitle>
                <DialogDescription> Use your QR scanner to scan the QR below </DialogDescription>
            </DialogHeader>

            <img class="aspect-1 h-auto w-full border" :src="qrUrl" alt="QR Code" />

            <p class="text-center">
                <a :href="shortUrl" target="_blank" class="text-sm text-muted-foreground">
                    {{ shortUrl }}
                </a>
            </p>

            <Button variant="outline">
                <a :href="qrUrl" download>Download</a>
            </Button>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog'
import { QrCodeIcon } from 'lucide-vue-next'
import { computed } from 'vue'

interface Props {
    shortUrl: string
}

const props = defineProps<Props>()

const shortPath = computed(() => {
    return props.shortUrl.split('/').pop()
})

const qrUrl = computed(() => {
    return `/api/v1/public-short-urls/${shortPath.value}/qr-codes`
})
</script>

<style scoped></style>
